import React, { useEffect, useState, useRef } from "react";
import { useForm } from 'react-hook-form';
import { MdOutlineDoneAll } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { InStockP, DoneDiv, EditProductButton, EditImgInput, EditProductDiv, EditProductInput, ProductsDiv, ProductsInfoDiv, SortSpan, SortDiv, SearchProducts, SearchDivIconDiv } from "./styled";
import { FaEdit } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import { FaSearch } from "react-icons/fa";

export const MyAboutList = React.memo(() => {
  const { register, handleSubmit } = useForm();
  const itemsPerPage = 20;
  const [products, setProducts] = useState([]);
  const [editProductIndex, setEditProductIndex] = useState(null);
  const [sortProducts, setSortProducts] = useState("minMax");
  const [sortProductsBoolean, setSortProductsBoolean] = useState(true);
  const [visibleItems, setVisibleItems] = useState(itemsPerPage);
  const [searchProducts, setSerachProducts] = useState('')

  const containerRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const req = await fetch("https://server.mayyanart.com/about-get")
        const res = await req.json();
        setProducts(res.about);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();

  }, [editProductIndex]);

  const deleteProduct = async (i) => {
    try {
      const ProductsToDelete = products[i];
      const req = await fetch(`https://server.mayyanart.com/about/${ProductsToDelete._id}`, {
        method: "DELETE",
      });

      if (req.ok) {
        const updatedproducts = products.filter((_, index) => index !== i);
        setProducts(updatedproducts);
        setEditProductIndex(null);
      } else {
        console.error("Не удалось удалить обзор");
      }
    } catch (err) {
      console.log(err);
    }
  };
  const changeProduct = async (data, i) => {
    try {
      const formData = new FormData();
      formData.append('textAM', data?.textAM?.trim() !== '' ? data.textAM : products[i].textAM);
      formData.append('titleAM', data?.titleAM?.trim() !== '' ? data.titleAM : products[i].titleAM);
      formData.append('textRU', data?.textRU?.trim() !== '' ? data.textRU : products[i].textRU);
      formData.append('titleRU', data?.titleRU?.trim() !== '' ? data.titleRU : products[i].titleRU);
      formData.append('textEN', data?.textEN?.trim() !== '' ? data.textEN : products[i].textEN);
      formData.append('titleEN', data?.titleEN?.trim() !== '' ? data.titleEN : products[i].titleEN);
      formData.append('activ', data?.activ !== '' ? data.activ : products[i].activ);
      
      console.log(formData);
      const req = await fetch(`https://server.mayyanart.com/about/${products[i]._id}`, {
        method: "PUT",
        body: formData,
      });
      if (req.ok) {
        const updatedProducts = [...products];
        updatedProducts[i] = { ...updatedProducts[i], ...data };
        console.log(updatedProducts);

        setProducts(updatedProducts);
        setEditProductIndex(null);

      } else {
        console.error("Не удалось обновить продукт");

      }

    } catch (err) {
      console.log(err);
    }
  };

  const toggleEditProduct = (index) => {
    setEditProductIndex((e) => (e === index ? null : index));
  };



  const handleScroll = () => {
    const container = containerRef.current;
    if (container) {
      const isAtBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight - 20;


      if (isAtBottom) {
        setVisibleItems((prevVisibleItems) => prevVisibleItems + itemsPerPage);
      }
    }
  };

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  return (
    <>

      <ProductsDiv ref={containerRef}>
        <SortDiv>
          <SearchProducts placeholder='search' onChange={(e) => setSerachProducts(e.target.value)} />
          <SearchDivIconDiv>
            <FaSearch />
          </SearchDivIconDiv>
        </SortDiv>

        {products?.filter(
          (e) =>
            e.textAM?.toLowerCase().includes(searchProducts.toLowerCase()) ||
            e.titleAM?.toLowerCase().includes(searchProducts.toLowerCase())||
            e.textRU?.toLowerCase().includes(searchProducts.toLowerCase()) ||
            e.titleRU?.toLowerCase().includes(searchProducts.toLowerCase())||
            e.textEN?.toLowerCase().includes(searchProducts.toLowerCase()) ||
            e.titleEN?.toLowerCase().includes(searchProducts.toLowerCase())
        ).slice(0, visibleItems)?.map((e, i) => (
          <ProductsInfoDiv key={e._id}>

            <DoneDiv>
              <button onClick={() => toggleEditProduct(i)}>{<FaEdit />} </button>
              <span> </span>
              <button onClick={() => deleteProduct(i)}> {<RxCross1 />}</button>
            </DoneDiv>
            <p>Վերնագիր: {e.titleAM}</p>
            <p>Տեքստ: {e.textAM}</p>
            <p>Վերնագիր: {e.titleRU}</p>
            <p>Տեքստ: {e.textRU}</p>
            <p>Վերնագիր: {e.titleEN}</p>
            <p>Տեքստ: {e.textEN}</p>
            <p>Կարգավիճակ: {e.activ ? <span style={{color:"green"}}>Ցուցադրվում է</span > : <span style={{color:"red"}}>Չի ցուցադրվում</span>}</p>

            {editProductIndex === i && (
              <EditProductDiv onSubmit={handleSubmit((data) => changeProduct(data, i))}>
                <EditProductInput placeholder="Վերնագիր AM"  {...register("titleAM")} /><br />
                <EditProductInput placeholder="Տեքստ AM"  {...register("textAM")} /><br />
                <EditProductInput placeholder="Վերնագիր RU"  {...register("titleRU")} /><br />
                <EditProductInput placeholder="Տեքստ RU"  {...register("textRU")} /><br />
                <EditProductInput placeholder="Վերնագիր EN"  {...register("titleEN")} /><br />
                <EditProductInput placeholder="Տեքստ EN"  {...register("textEN")} /><br />
                <label><input placeholder="Կարգավիճակ" type="checkbox"  {...register("activ")}  style={{marginTop:"30px"}}/> Կարգավիճակ</label><br />
                <EditProductButton>Փոփոխել</EditProductButton>
              </EditProductDiv>
            )}
            <hr />

          </ProductsInfoDiv>

        ))}

      </ProductsDiv>
    </>
  );
});
